import React from 'react';
import invisalignLogo from '../../assets/icons/align-logo.svg';
import sparkLogo from '../../assets/icons/spark-logo.svg';
import { useSubmissionForm } from '../../providers/patient/PatientSubmissionContext';

const TreatmentPlan: React.FC = () => {
    const { formData } = useSubmissionForm();

    return (
        <div className="border border-gray-200 rounded-xl w-full">
            <div className="bg-blue-50 p-3 rounded-t-xl">
                <h3 className="text-lg font-bold text-gray-800">
                    {formData?.caseType?.label || formData?.caseType?.monday_key || '—'}
                    {' - '}
                    {formData?.subCaseType &&
                        (formData?.subCaseType?.title || formData?.subCaseType?.monday_key || '')}
                </h3>
            </div>
            <div className="p-5 flex justify-between items-start">
                <div className="w-2/3">
                    <h4 className="text-sm font-bold text-gray-800 mb-2">Treatment Plan</h4>
                    <ul className=" mt-2 list-disc list-inside px-2 space-y-3 text-sm text-[#6B7280]">
                        {formData?.subCaseType?.benefits &&
                            Object.keys(formData?.subCaseType?.benefits).map((benefit: string) => (
                                <li key={`b-${benefit}`}>
                                    <span className="font-bold">{benefit} : </span>
                                    <span className="font-normal">
                                        {formData?.subCaseType?.benefits[benefit]}
                                    </span>
                                </li>
                            ))}
                    </ul>
                </div>
                <div className="flex flex-col items-center justify-center w-1/3 pl-4">
                    <h4 className="text-sm font-bold text-gray-800 mb-2">Aligner manufacturer</h4>
                    {formData?.manufacturer === 'Spark Aligners' && (
                        <img src={sparkLogo} alt="Spark Logo" className="w-full" />
                    )}
                    {formData?.manufacturer === 'Invisalign Aligners' && (
                        <img src={invisalignLogo} alt="Invisalign Logo" className="w-full" />
                    )}
                    {!formData?.manufacturer && (
                        <span className="text-sm text-gray-500">Not specified</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TreatmentPlan;
